import { Component, OnInit, Input ,Output, ViewChild, EventEmitter } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ProductosProvider } from '../../providers/productos/productos'
import { ProveedoresProvider } from '../../providers/proveedores/proveedores'
import { ProveedoresCargarStockProvider } from '../../providers/proveedores-cargar-stock/proveedores-cargar-stock'
import { Observable } from 'rxjs/Observable';

// import { Http, Response, RequestOptions, Headers } from '@angular/http';  

// import { FormControl } from '@angular/forms';
import { GridProveedoresPage } from '../grid-proveedores/grid-proveedores';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'

@IonicPage()
@Component({
  selector: 'page-proveedores-cargar-stock',
  templateUrl: 'proveedores-cargar-stock.html',
  providers: [ AuthService ]
})
export class ProveedoresCargarStockPage {
  listaProveedores: any = []
  listaProductos: any = []
  proveedoresId


  rows;

  tableHover: boolean = true;
  tableStriped: boolean;
  tableCondensed: boolean;
  tableBordered: boolean;
  keyword: string ="";
  keywordColumnas: string="";
  @Input() tablajsoncolumnas : any = []
  headers;
  // searchControl: FormControl = new FormControl();
  // searchControlColumnas: FormControl = new FormControl();
  tablajsonrespuesta :string = ""
  tablafuncionagregado : string= "";
  cadenaTabla : string = "";
  cadenaColumna : string = "";
  jsoncondicionalconsultaagrupado: string ="";
  nombreprocedimiento: string = "";
  valorprocedimiento: string =""
  columnasArray :Array<Object> = []
  tablajson :Array<Object> = []
  camposAgrupar:Array<Object> = [];
  consultaagregadoArray: Array<Object> = [];
  campoConsultaAgregadoArray: Array<Object> = [];
  cadenaConsultaAgregado: string = "";
  ConsultaAgregadoArray : Array<Object> = [];
  cadenaConsultaAgregadoArray: string ="";
  consultaagregadoArrayArmarQuery : Array<Object> = [];
  agregarCampoConsultaAgregadoArray : Array<Object> = [];
  cadenaColumnaArray  : Array<Object> = [];
  

  @ViewChild('appwhere') WhereComponent : GridProveedoresPage;
  
   

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public servicioProveedores:ProveedoresProvider,
             public servicioProductos: ProductosProvider,
             public servicioStock:ProveedoresCargarStockProvider ,
             public servicioCompania:CompaniasProvider,
             public auth: AuthService
           ) {
               this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
               .then((val)=>{
                 if(val){
                   this.nombreCompaniaHeader = val['nombreCompania']
                   this.nombreCargoHeader = val['nombreCargo']
                 }
               })
         
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProveedoresCargarStockPage');
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }  

}



// WEBPACK FOOTER //
// ./src/pages/proveedores-cargar-stock/proveedores-cargar-stock.ts